import { userChannelSubscriptionPaymentFailed } from '../utils/channelSubscriptions.utils';
import { formatDisplayDate } from '../utils/date.utils';
import { Channel, ChannelSubscription, ChannelSubscriptionType, ChannelTypes } from './types';

export const getDisplayProperties = (userChannelSubscription: ChannelSubscription, channel?: Channel) => {
	const isSubscriptionActive = userChannelSubscription?.subscriptionState === 'active';
	const cancelRequestedAt = formatDisplayDate(userChannelSubscription?.cancelRequestedAt, false) ?? '';
	const cancelAt = formatDisplayDate(userChannelSubscription?.cancelAt, false) ?? '';
	const cancelAtPeriodEnd = userChannelSubscription?.subscriptionState === 'active' && userChannelSubscription?.cancelAtPeriodEnd;
	const subscriptionPaymentFailed = userChannelSubscriptionPaymentFailed(userChannelSubscription?.subscriptionState);
	const paymentFailedAlertVisible = subscriptionPaymentFailed && !userChannelSubscription?.cancelAtPeriodEnd;
	const subscriptionPendingCancel = (userChannelSubscription?.subscribed || subscriptionPaymentFailed) && userChannelSubscription?.cancelAtPeriodEnd;
	const isNonChargeCancelled = userChannelSubscription?.subscriptionType === ChannelSubscriptionType.NonCharge && userChannelSubscription?.subscriptionState === 'canceled';
	const isAccountCancelled = userChannelSubscription?.subscriptionType === ChannelSubscriptionType.Account && userChannelSubscription?.subscriptionState === 'canceled';
	const isFreeOpenChannel = channel?.type === ChannelTypes.freeOpen;
	const isFreeClosedChannel = channel?.type === ChannelTypes.freeClosed;
	const isPremiumChannel = channel?.type === ChannelTypes.premium;


	const subscribeButtonVisible = userChannelSubscription?.subscriptionType === ChannelSubscriptionType.Trial
		|| isFreeOpenChannel
		|| isFreeClosedChannel
		|| isNonChargeCancelled
		|| (isAccountCancelled && !userChannelSubscription?.subscribed && userChannelSubscription?.cancelAtPeriodEnd)
		|| (!subscriptionPaymentFailed && !userChannelSubscription?.subscribed && !userChannelSubscription?.cancelAtPeriodEnd);

	const nonChargeSubscriptionExpired = userChannelSubscription?.subscriptionState === 'expired' &&
		userChannelSubscription?.subscriptionType === ChannelSubscriptionType.NonCharge &&
		!!userChannelSubscription?.acknowledgedNonChargeSubExpired;

	const isTrialSubscriptionActive = userChannelSubscription?.subscriptionType === ChannelSubscriptionType.Trial &&
		userChannelSubscription?.subscriptionState === 'active';

	const isTrialSubscriptionExpired = userChannelSubscription?.subscriptionType === ChannelSubscriptionType.Trial &&
		userChannelSubscription?.subscriptionState === 'expired';

	const isTrialSubscriptionPending = userChannelSubscription?.subscriptionType === ChannelSubscriptionType.Trial &&
		userChannelSubscription?.subscriptionState === 'pending';

	const freeClosedRequestRejected = userChannelSubscription?.subscriptionState === 'rejected';
	const freeClosedRequestPending = userChannelSubscription?.subscriptionType === ChannelSubscriptionType.Free &&
		userChannelSubscription?.subscriptionState === 'pending';

	const freeClosedUnsubscribed = userChannelSubscription?.subscriptionType === ChannelSubscriptionType.Free &&
		userChannelSubscription?.subscriptionState === 'canceled';

	return {
		isFreeOpenChannel,
		isFreeClosedChannel,
		isPremiumChannel,
		freeClosedRequestRejected,
		freeClosedRequestPending,
		freeClosedUnsubscribed,
		isSubscriptionActive,
		subscriptionPaymentFailed,
		nonChargeSubscriptionExpired,
		subscriptionPendingCancel,
		cancelRequestedAt,
		cancelAt,
		cancelAtPeriodEnd,
		paymentFailedAlertVisible,
		subscribeButtonVisible,
		isTrialSubscriptionActive,
		isTrialSubscriptionExpired,
		isTrialSubscriptionPending
	};
}
